import { Eye, EyeOff } from 'lucide-react'
import { useState } from 'react'

import { Input } from '#components/ui/input.jsx'
import { cn } from '#components/utils.js'

export function PasswordInput({
  className,
  disabled,
  visibilityLabel = 'password',
  ...props
}) {
  const [visible, setVisible] = useState(false)
  const Icon = visible ? EyeOff : Eye
  return (
    <div className='relative'>
      <Input
        {...props}
        className={cn('pr-12', className)}
        disabled={disabled}
        type={visible ? 'text' : 'password'}
      />
      <button
        aria-label={`${visible ? 'Hide' : 'Show'} ${visibilityLabel}`}
        aria-pressed={visible}
        className='absolute inset-y-0 right-0 flex w-11 items-center justify-center rounded-r-md text-muted-foreground hover:text-foreground focus-visible:outline-2 focus-visible:outline-ring disabled:cursor-not-allowed disabled:opacity-60'
        disabled={disabled}
        onClick={() => setVisible(value => !value)}
        type='button'
      >
        <Icon aria-hidden='true' className='size-4' />
      </button>
    </div>
  )
}
